(function() {
  var TRACKING_URL = window.WC_PRODUCT_FINDER_TRACKING_URL || '';
  var TRACKING_KEY = window.WC_PRODUCT_FINDER_TRACKING_KEY || '';
  var SESSION_KEY = 'wc_pf_tracking_session';
  var SEQ_KEY = 'wc_pf_tracking_sequence';
  var CONTEXT_KEY = 'wc_pf_last_product_context';
  var SAVED_KEY = 'wc_saved_products';
  var WTB_OPEN_KEY = 'wc_pf_wtb_open_ts';

  function allowed() {
    try {
      if (window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.analyticsProcessingAllowed === 'function') {
        return Shopify.customerPrivacy.analyticsProcessingAllowed();
      }
    } catch(e) {}
    return true;
  }
  function makeId(prefix) {
    try { if (crypto && crypto.randomUUID) return prefix + '_' + crypto.randomUUID(); } catch(e) {}
    return prefix + '_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2,10);
  }
  function sessionId() {
    try {
      var id=sessionStorage.getItem(SESSION_KEY);
      if(!id){id=makeId('pf');sessionStorage.setItem(SESSION_KEY,id);}
      return id;
    } catch(e){return makeId('pf');}
  }
  function sequence() {
    try { var n=parseInt(sessionStorage.getItem(SEQ_KEY)||'0',10)+1; sessionStorage.setItem(SEQ_KEY,String(n)); return n; }
    catch(e){return 1;}
  }
  function device(){var w=innerWidth||0;return w<768?'Mobile':w<1100?'Tablet':'Desktop';}
  function loadSaved(){try{return JSON.parse(localStorage.getItem(SAVED_KEY))||[];}catch(e){return[];}}
  function savedSnapshot(){
    var list=loadSaved();
    var normalized=list.map(function(p){return {sku:p.sku||'',category:p.cat||'',collection:p.col||'',price:Number(p.price||0)||0};});
    return {count:normalized.length,skus:normalized.map(function(p){return p.sku;}).filter(Boolean).sort().join(' | '),total:normalized.reduce(function(s,p){return s+p.price;},0),json:JSON.stringify(normalized)};
  }
  function currentContext(){
    try {
      var ctx=JSON.parse(localStorage.getItem(CONTEXT_KEY)||'null');
      if(!ctx || !ctx.timestamp || Date.now()-ctx.timestamp > 24*60*60*1000) return {};
      if(ctx.product_url){
        try {
          var expected=new URL(ctx.product_url,location.origin).pathname.replace(/\/$/,'');
          var actual=location.pathname.replace(/\/$/,'');
          if(expected && actual && expected!==actual) return {};
        } catch(e){}
      }
      return ctx;
    } catch(e){return {};}
  }
  function send(eventName,extra){
    if(!TRACKING_URL || !TRACKING_KEY || !allowed()) return;
    var ctx=currentContext(), saved=savedSnapshot();
    var payload=Object.assign({
      tracking_key:TRACKING_KEY,
      client_timestamp:new Date().toISOString(),session_id:sessionId(),sequence:sequence(),event:eventName,
      page_url:location.href,page_path:location.pathname,referrer:document.referrer||'',device:device(),
      saved_count:saved.count,saved_skus:saved.skus,saved_total_list_price:saved.total,saved_list_json:saved.json,
      event_id:makeId('evt'),user_agent:navigator.userAgent||''
    },ctx,extra||{});
    try{fetch(TRACKING_URL,{method:'POST',mode:'no-cors',keepalive:true,headers:{'Content-Type':'text/plain;charset=utf-8'},body:JSON.stringify(payload)}).catch(function(){});}catch(e){}
  }
  function retailerForUrl(href){
    try{
      var h=new URL(href,location.href).hostname.toLowerCase().replace(/^www\./,'');
      function is(d){return h===d||h.endsWith('.'+d);}
      if(is('modernbathroom.com')) return 'Modern Bathroom';
      if(is('homedepot.com')) return 'Home Depot';
      if(is('lowes.com')) return "Lowe's";
      if(is('ferguson.com')||is('fergusonhome.com')) return 'Ferguson';
      if(is('build.com')) return 'Build.com';
      if(is('wayfair.com')) return 'Wayfair';
      if(is('menards.com')) return 'Menards';
      return '';
    }catch(e){return '';}
  }
  function textOf(el){return ((el && (el.innerText||el.textContent))||'').replace(/\s+/g,' ').trim();}

  // Attribute a PDP view back to the finder when the URL matches the stored SKU context.
  if(location.pathname.indexOf('/products/')===0 && Object.keys(currentContext()).length){
    send('PDP_VIEW_FROM_FINDER',{source_element:'product_page'});
  }

  document.addEventListener('click',function(e){
    // Where to Buy accordion: <details class="where-to-buy__accordion"><summary>...
    var summary=e.target.closest('summary');
    if(summary){
      var details=summary.closest('details');
      var isWtb=(details && /where-to-buy/.test(details.className||'')) || textOf(summary).toLowerCase().indexOf('where to buy')!==-1;
      // Click fires before the toggle, so details.open === false means it is about to open.
      if(isWtb && !(details && details.open)){
        try{sessionStorage.setItem(WTB_OPEN_KEY,String(Date.now()));}catch(x){}
        send('WHERE_TO_BUY_OPEN',{source_element:'where_to_buy'});
      }
      return;
    }
    var target=e.target.closest('a,button,[role="button"]');
    if(!target) return;
    var label=textOf(target).toLowerCase();
    var aria=(target.getAttribute('aria-label')||'').toLowerCase();
    if(label.indexOf('where to buy')!==-1 || aria.indexOf('where to buy')!==-1){
      try{sessionStorage.setItem(WTB_OPEN_KEY,String(Date.now()));}catch(x){}
      send('WHERE_TO_BUY_OPEN',{source_element:'where_to_buy'});
      return;
    }
    var link=target.closest('a[href]');
    if(!link) return;
    var inWtb=!!link.closest('.where-to-buy__row,.where-to-buy__content,.where-to-buy__accordion');
    var retailer=retailerForUrl(link.href);
    if(!retailer && inWtb){
      try{retailer=new URL(link.href,location.href).hostname.replace(/^www\./,'');}catch(x){}
    }
    if(!retailer) return;
    // Retailer links inside the Where to Buy block always count; elsewhere only on product pages.
    if(!inWtb && location.pathname.indexOf('/products/')!==0) return;
    send('WHERE_TO_BUY_RETAILER_CLICK',{retailer:retailer,retailer_url:link.href,source_element:'retailer_link'});
  },true);
})();
